<template>
    <b-modal 
        :id="modalId"
        ref="modal"
        :title="tituloModal"
        size="md"
        hide-footer
    >
        <div class="form-group required">
            <label for="favorito-titulo">Título do modelo</label>
            <b-form-input 
                id="favorito-titulo"
                v-model="form.titulo"
                placeholder="Ex: Relatório de vendas mensal"
                :class="{ error: erros.titulo }"
            />
            <small v-if="erros.titulo" class="text-danger">{{ erros.titulo }}</small>
        </div>
        
        <div class="form-group">
            <label for="favorito-descricao">Descrição</label>
            <b-form-textarea 
                id="favorito-descricao"
                v-model="form.descricao"
                placeholder="Descreva brevemente o que este modelo faz..."
                rows="2"
            />
        </div>
        
        <div class="form-group">
            <label>Categorias</label>
            <div class="categorias-favorito">
                <label 
                    v-for="cat in categorias" 
                    :key="cat.value"
                    class="categoria-chip"
                    :class="{ selected: form.categorias.includes(cat.value) }"
                >
                    <input 
                        type="checkbox" 
                        :value="cat.value"
                        v-model="form.categorias"
                    >
                    <i :class="cat.icon" class="mr-1"></i>
                    {{ cat.label }}
                </label>
            </div>
            <small v-if="erros.categorias" class="text-danger">{{ erros.categorias }}</small>
        </div>
        
        <div class="form-group required">
            <label for="favorito-comando">Comando</label>
            <b-form-textarea 
                id="favorito-comando"
                v-model="form.comando"
                rows="3"
                placeholder="Digite o comando/pergunta para o assistente..."
                :readonly="modoEdicao && !form.isProprio"
                :class="{ 'bg-light': modoEdicao && !form.isProprio }"
            />
            <small v-if="modoEdicao && !form.isProprio" class="text-muted">
                Este é um modelo do sistema/comunidade. Uma cópia será criada ao salvar.
            </small>
        </div>
        
        <!-- Footer customizado -->
        <div class="modal-footer-custom mt-4 pt-3 border-top">
            <div class="footer-left">
                <!-- Desfavoritar (só em modo edição e prompt próprio) -->
                <button 
                    v-if="modoEdicao && form.isProprio"
                    type="button"
                    class="btn btn-danger btn-sm"
                    @click="confirmarDesfavoritar"
                    :disabled="salvando"
                >
                    <i class="fa glyphicon glyphicon-remove mr-1"></i>
                    Remover
                </button>
            </div>
            <div class="footer-right">
                <button 
                    type="button"
                    class="btn btn-secondary btn-sm mr-2"
                    @click="fechar"
                >
                    Cancelar
                </button>
                
                <button 
                    type="button"
                    class="btn btn-primary btn-sm"
                    @click="salvar({ preventDefault: () => {} })"
                    :disabled="salvando"
                >
                    {{ okTitulo }}
                </button>
            </div>
        </div>
    </b-modal>
</template>

<script>
import { create } from "@/shared/services/api.js"

export default {
    name: 'ModalPromptFavoritos',
    
    props: {
        modalId: {
            type: String,
            default: 'modal-prompt-favoritos'
        }
    },
    
    data() {
        return {
            apiIA: null,
            salvando: false,
            modoEdicao: false, // false = criar novo, true = editar existente
            form: {
                id: null,
                titulo: '',
                descricao: '',
                categorias: [],
                comando: '',
                is_public: false,
                mensagemOriginal: null,
                // Para prompts do sistema/comunidade
                isProprio: true,
                originalId: null
            },
            erros: {
                titulo: '',
                categorias: ''
            },
            categorias: [
                { value: 'financeiro', label: 'Financeiro', icon: 'fa fa-money' },
                { value: 'fiscal', label: 'Fiscal', icon: 'fa fa-file-text-o' },
                { value: 'vendas', label: 'Vendas', icon: 'fa fa-shopping-cart' },
                { value: 'atendimento', label: 'Atendimento', icon: 'fa fa-headphones' },
                { value: 'estoque', label: 'Estoque', icon: 'fa fa-archive' },
                { value: 'estrategia', label: 'Estratégia', icon: 'fa fa-line-chart' }
            ]
        }
    },
    
    computed: {
        tituloModal() {
            if (!this.modoEdicao) return 'Salvar nos favoritos'
            if (this.form.isProprio) return 'Editar modelo'
            return 'Criar cópia do modelo'
        },
        okTitulo() {
            if (this.salvando) return 'Salvando...'
            if (!this.modoEdicao) return 'Salvar'
            if (this.form.isProprio) return 'Salvar'
            return 'Criar cópia'
        }
    },
    
    created() {
        const apiUrl = process.env.VUE_APP_API_IA_URL || 'https://ia.click.app/api'
        // intranet (FastAPI) espera JSON, não multipart
        this.apiIA = create(apiUrl, 'application/json')
    },
    
    methods: {
        // Abre para criar novo (a partir de mensagem do chat)
        abrir(mensagem) {
            this.modoEdicao = false
            this.form = {
                id: null,
                titulo: '',
                descricao: '',
                categorias: [],
                comando: mensagem.content || '',
                is_public: false,
                mensagemOriginal: mensagem,
                isProprio: true,
                originalId: null
            }
            this.erros = { titulo: '', categorias: '' }
            this.salvando = false
            
            this.$refs.modal.show()
        },
        
        // Abre para editar prompt existente
        abrirEdicao(prompt) {
            this.modoEdicao = true
            const isProprio = prompt.usuario_id != null
            this.form = {
                id: prompt.id,
                titulo: prompt.titulo || prompt.nome || '',
                descricao: prompt.descricao || '',
                categorias: Array.isArray(prompt.categorias) ? [...prompt.categorias] : [prompt.categoria].filter(Boolean),
                comando: prompt.comando || '',
                is_public: prompt.is_public || false,
                mensagemOriginal: null,
                isProprio: isProprio,
                originalId: prompt.id
            }
            this.erros = { titulo: '', categorias: '' }
            this.salvando = false
            
            this.$refs.modal.show()
        },
        
        fechar() {
            this.$refs.modal.hide()
        },
        
        async salvar(bvModalEvt) {
            bvModalEvt.preventDefault()
            
            // Validação
            this.erros = { titulo: '', categorias: '' }
            let valido = true
            
            if (!this.form.titulo.trim()) {
                this.erros.titulo = 'O título é obrigatório'
                valido = false
            }
            
            if (this.form.categorias.length === 0) {
                this.erros.categorias = 'Selecione pelo menos uma categoria'
                valido = false
            }
            
            if (!valido) return
            
            this.salvando = true
            
            try {
                let response
                let mensagem = ''
                
                if (!this.modoEdicao) {
                    // Criar novo
                    response = await this.apiIA.post('/v1/prompts', {
                        titulo: this.form.titulo,
                        descricao: this.form.descricao,
                        categorias: this.form.categorias,
                        comando: this.form.comando,
                        is_public: false
                    })
                    mensagem = 'Modelo salvo nos favoritos!'
                } else if (this.form.isProprio) {
                    // Editar próprio
                    response = await this.apiIA.put(`/v1/prompts/${this.form.id}`, {
                        titulo: this.form.titulo,
                        descricao: this.form.descricao,
                        categorias: this.form.categorias,
                        comando: this.form.comando,
                        is_public: this.form.is_public
                    })
                    mensagem = 'Modelo atualizado com sucesso!'
                } else {
                    // Criar cópia de prompt do sistema/comunidade
                    response = await this.apiIA.post('/v1/prompts', {
                        titulo: this.form.titulo,
                        descricao: this.form.descricao,
                        categorias: this.form.categorias,
                        comando: this.form.comando,
                        is_public: false
                    })
                    
                    // Desfavorita o original
                    try {
                        await this.apiIA.delete(`/v1/prompts/${this.form.originalId}/favoritar`)
                    } catch (e) {
                        // Ignora erro
                    }
                    mensagem = 'Cópia criada nos seus favoritos!'
                }
                
                if (response && (response.code === 201 || response.code === 200)) {
                    this.$notify.success(mensagem)
                    
                    this.$emit('salvar', {
                        ...(response.data || {}),
                        mensagemOriginal: this.form.mensagemOriginal,
                        modoEdicao: this.modoEdicao
                    })
                    
                    this.fechar()
                } else {
                    throw new Error(response?.message || 'Erro ao salvar')
                }
            } catch (error) {
                console.error('Erro ao salvar prompt:', error)
                this.$notify.error(error.response?.data?.message || 'Erro ao salvar modelo')
            } finally {
                this.salvando = false
            }
        },
        
        // Confirmação para desfavoritar/remover
        async confirmarDesfavoritar() {
            const confirmacao = await this.$dialog.confirm(
                'Tem certeza que deseja remover este modelo dos seus favoritos?',
                {
                    icon: 'glyphicon glyphicon-trash',
                }
            )
            
            if (confirmacao) {
                await this.desfavoritar()
            }
        },
        
        async desfavoritar() {
            if (!this.form.id) return
            
            this.salvando = true
            
            try {
                // Remove o prompt (que também remove dos favoritos)
                await this.apiIA.delete(`/v1/prompts/${this.form.id}`)
                
                this.$notify.success('Modelo removido com sucesso!')
                
                this.$emit('salvar', {
                    id: this.form.id,
                    removido: true
                })
                
                this.fechar()
            } catch (error) {
                console.error('Erro ao remover:', error)
                this.$notify.error(error.response?.data?.message || 'Erro ao remover modelo')
            } finally {
                this.salvando = false
            }
        }
    }
}
</script>

<style scoped>
.categorias-favorito {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.categoria-chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 6px 12px;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.85rem;
    color: #666;
    transition: all 0.2s;
    margin: 0;
}

.categoria-chip:hover {
    border-color: rgb(36, 61, 75);
    color: rgb(36, 61, 75);
}

.categoria-chip.selected {
    background: rgb(36, 61, 75);
    border-color: rgb(36, 61, 75);
    color: #fff;
}

.categoria-chip input {
    display: none;
}

.error {
    border-color: #dc3545 !important;
}

.alert-sm {
    padding: 8px 12px;
    font-size: 0.85rem;
}

.modal-footer-custom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: -1rem;
    margin-right: -1rem;
    margin-bottom: -1rem;
    padding: 1rem;
    background: #f8f9fa;
    border-radius: 0 0 0.3rem 0.3rem;
}

.footer-left {
    display: flex;
    align-items: center;
}

.footer-right {
    display: flex;
    align-items: center;
}
</style>

